import { useState, useEffect } from 'react';
import CampusHeader from '../../components/feature/CampusHeader';
import Footer from '../../components/feature/Footer';
import { subscribeAuth, getUserProfile } from '../../services/auth';
import { useNavigate } from 'react-router-dom';

const PendingVerificationPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = subscribeAuth(async (user) => {
      setIsLoggedIn(!!user);
      if (!user) {
        navigate('/');
      } else {
        try {
          const profile = await getUserProfile(user.uid);
          setUserProfile(profile);
        } catch (error) {
          console.error('Error fetching user profile:', error);
        } finally {
          setLoading(false);
        }
      }
    });
    return () => unsub();
  }, [navigate]);

  if (!isLoggedIn) return null;
  if (loading) return null;

  return (
    <div className="min-h-screen bg-gray-50">
      <CampusHeader />
      <main className="max-w-md mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          {userProfile?.status === 'rejected' ? (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-red-600 text-2xl font-bold">✕</span>
              </div>
              <h1 className="text-2xl font-bold text-gray-900 mb-4">Account Verification Rejected</h1>
              {userProfile?.rejectionReason && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                  <h3 className="font-semibold text-red-800 mb-2">Reason for rejection:</h3>
                  <p className="text-red-700">{userProfile.rejectionReason}</p>
                  {userProfile?.rejectionDate && (
                    <p className="text-sm text-red-600 mt-2">
                      Rejected on: {new Date(userProfile.rejectionDate).toLocaleDateString()}
                    </p>
                  )}
                </div>
              )}
              <p className="text-gray-600 mb-8">
                Your account verification was rejected. Please review the reason above and re-upload your verification documents.
              </p>
              <div className="space-y-4">
                <button
                  onClick={() => navigate('/sell')}
                  className="w-full bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-colors font-medium"
                >
                  Re-upload Verification Documents
                </button>
                <button
                  onClick={() => navigate('/')}
                  className="w-full bg-gray-200 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                >
                  Return to Home
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-yellow-600 text-2xl font-bold">!</span>
              </div>
              <h1 className="text-2xl font-bold text-gray-900 mb-4">Account Pending Verification</h1>
              <p className="text-gray-600 mb-8">
                Your account has been created successfully but is pending manual verification by our team.
                We'll notify you via email once your account is verified and ready to use.
              </p>
              <button
                onClick={() => navigate('/')}
                className="bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-colors font-medium"
              >
                Return to Home
              </button>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PendingVerificationPage;